import React from "react";
import useSizePercentage from "../hooks/useSizePercentage";

const DetailedNumberHolder = ({ number, ending, name, icon, boolean }) => {
  const sizePercentage = useSizePercentage();
  return (
    <div className="divColumn" style={{ width: "100%" }}>
      <div
        className="divRow"
        style={{
          width: "70%",
          justifyContent: "center",
          position: "relative",
          padding: "5px",
          marginBottom: "2px",
        }}
      >
        <div
          style={{
            opacity: 0.7,
            borderRadius: ".5rem/.5rem",
            backgroundColor: "#5f5f5f",
            width: "100%",
            height: "100%",
            position: "absolute",
          }}
        />
        <div
          className="textBoldWhite"
          style={{
            zIndex: 1,
            fontSize: sizePercentage.width < 85 ? "12px" : "16px",
          }}
        >
          {name}
        </div>
      </div>

      <div className="divRow" style={{ width: "40%" }}>
        <img src={icon} className="icon25" />
        <div
          className="textBold"
          style={{ flex: 1, textAlign: "center", color: "#1f1f1f" }}
        >
          {ending}
        </div>
      </div>
    </div>
  );
};

export default DetailedNumberHolder;
